<template>
    <section class="home-page__02" :style="`background-image: url(${VIDEO_NEWS_BG})`">
        <video id="home-page02-video" muted preload class="bg" :style="`opacity: ${videoShow}`" loop :src="VIDEO_NEWS" @canplaythrough="loaded"></video>
        <img class="title" src="../../assets/images/home/page02/title.png" alt="title">
        <div class="box-wrap">
            <div class="news-box-shadow">
                <div class="new-box">
                    <div class="new-box__content">
                        <div class="new-box__tagbox">
                            <div class="new-box-tag" :key="`tag-${index}`" v-for="(item, index) in tagList" @click="selectedTag(item, index)">
                                <img :src="item.url" :class="{'news-tag-actived': index == tagIndex}" alt="">
                            </div>
                        </div>
                        <div class="new-box__itembox" ref="newsScroll" @scroll="newScroll">
                            <div class="new-box__item" v-for="(item, index) in newList" :key="index" @click="showNews(item)">
                                <p class="new_other">
                                    <span class="new_other--time">{{ $utils.formatTime(item.publishedAt) }}</span>
                                    <span class="new_other--type">{{ formatNewsCategory(item.category) }}</span>
                                </p>
                                <p class="new_title">{{ item.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="twitter-box-shadow">
                <div class="twitter-box">
                    <img src="../../assets/images/home/page02/twitter_logo.png" class="twitter-box__logo" alt="">
                    <a target="_blank" href="https://twitter.com/Epic7_jp" class="twitter-box__a">
                        <img src="../../assets/images/home/page02/twitter_a.png" alt="">
                    </a>
                    <div class="twitter-box__content">
                        <a class="twitter-timeline" data-theme="dark" href="https://twitter.com/Epic7_jp?ref_src=twsrc%5Etfw">Tweets by Epic7_jp</a> 
                    </div>
                </div>
            </div>
        </div>
        <scroll-bar></scroll-bar>
        <pre-login></pre-login>
        <firefly class="left-firefly" zindex="2" dir="left"></firefly>
        <firefly class="right-firefly" zindex="2" dir="right"></firefly>
    </section>
</template>

<script>
import scrollBar from "../../components/scroll-bar";
import preLogin from "../../components/pre-login";
import firefly from "../../components/firefly";

export default {
    name: "home-page02",

    components: {
        "scroll-bar": scrollBar,
        "pre-login": preLogin,
        firefly
    },
    data: () => ({
        videoShow: 0,
        tagIndex: 0,
        newsType: undefined,
        tagList: [
            {
                url: require("../../assets/images/home/page02/tag_all.png"),
                tag: undefined
            },
            {
                url: require("../../assets/images/home/page02/tag_02.png"),
                tag: 1
            },
            {
                url: require("../../assets/images/home/page02/tag_03.png"),
                tag: 2
            },
            {
                url: require("../../assets/images/home/page02/tag_04.png"),
                tag: 3
            },
            {
                url: require("../../assets/images/home/page02/tag_05.png"),
                tag: 4
            }
        ],
        newList: [],
        getNewsAgain: false,
        getNewsPage: 1,
        newsScrollTimer: null,
        news_preToken: "",          // 预览参数
    }),
    created() {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://platform.twitter.com/widgets.js';
        document.body.appendChild(s);
        
        this.news_preToken = this.$route.query.userToken;
        this.getNewsList(false, 1)
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.$utils.setVideoSize("#home-page02-video", ".home-page__02");
        }, false);
    },
    watch: {
    },
    computed: {
        VIDEO_NEWS() {
            // return this.$store.state.VIDEO_ARR.NEWS;
            return require("../../assets/video/news.mp4")
        },
        VIDEO_NEWS_BG() {
            // return this.$store.state.VIDEO_BG.NEWS;
            return require("../../assets/images/home/page02/bg.png")
        }
    },
    methods: {
        showNews(item) {
            this.$store.commit("SET_NEWS", {
                status: true,
                content: item
            });
        },
        loaded() {
            this.$utils.setVideoSize("#home-page02-video", ".home-page__02");
            this.videoShow = 1;
            document.querySelector("#home-page02-video").play();
        },
        selectedTag(item, index) {
            this.tagIndex = index;
            this.newsType = item.tag;
            this.getNewsPage = 1;
            this.getNewsList(true, 1);
        },
        newScroll(event) {
            clearTimeout(this.newsScrollTimer)
            
            this.newsScrollTimer = setTimeout(() => {
                let newS_sheight = this.$refs.newsScroll.scrollHeight;  //元素实际高度
                let newS_Top = this.$refs.newsScroll.scrollTop;         // 元素滚动距离
                let newS_cHeight = this.$refs.newsScroll.clientHeight   //元素可视高度

                if((newS_sheight - newS_cHeight)* 0.9 <= newS_Top) {
                    this.getNewsAgain = true;
                    this.getNewsPage++;
                    this.getNewsList(false, this.getNewsPage)
                }
            }, 1000);
        },
        getNewsList(clear, page) {
            this.axios.get(`${process.env.VUE_APP_HOST}/news`, {
                params: {
                    lang: 'ja',
                    category: this.newsType,
                    page: page,
                    limit: 5,
                    userToken: this.news_preToken
                }
            }).then(v => {
                if(v.data.code == 20000) {
                    if(clear) {
                        this.newList = v.data.data.items
                    } else {
                        this.newList = this.newList.concat(v.data.data.items)
                    }
                }
                this.getNewsAgain = false;
            }).catch(e => {
                console.log(e)
                this.getNewsAgain = false;
            })
        },
        formatNewsCategory(index) {
            switch (index) {
                case 1:
                    return "お知らせ"
                    break;
                case 2:
                    return "イベント"
                    break;
                case 3:
                    return "アップデート"
                    break;
                case 4:
                    return "メンテナンス"
                    break;
                default:
                    break;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.home-page__02 {
    overflow: hidden;
    position: relative;
    background-position: center;
    background-size: cover;

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: url("../../assets/images/home/page02/streak.png");
        opacity: .2;
        z-index: 2;
    }
    
    .bg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
    }
    .title {
        position: absolute;
        z-index: 3;
        height: 100%;
        left: pxTorem(27px);
        opacity: 0.8;
    }
    .box-wrap {
        width: pxTorem(1400px);
        height: pxTorem(476px);
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translateX(-50%);
        z-index: 3;
        overflow: hidden;

        .news-box-shadow {
            width: pxTorem(700px);
            height: 100%;
            float: left;
            box-sizing: border-box;
            background: linear-gradient(to bottom, #34C3FF, #45FFC8);
            padding: 3px;
            
            .new-box {
                width: 100%;
                height: 100%;
                background: url("../../assets/images/home/page02/news_background.png") no-repeat center;
                background-size: cover;
                box-sizing: border-box;
                padding: pxTorem(110px) pxTorem(25px) pxTorem(26px);

                &__content {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    .new-box__tagbox {
                        width: 100%;
                        height: pxTorem(40px);
                        box-sizing: border-box;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        
                        .new-box-tag {
                            height: 45%;
                            cursor: pointer;
                            display: flex;

                            img {
                                display: block;
                                height: 100%;
                                filter: brightness(100);

                                &.news-tag-actived {
                                    filter: brightness(1);
                                }
                            }

                            &:not(:last-child)::after {
                                content: "|";
                                display: block;
                                width: 1px;
                                height: 100%;
                                background: #fff;
                                margin: 0 pxTorem(25px);
                            }
                        }
                    }

                    .new-box__itembox {
                        flex: 1;
                        overflow-y: auto;
                        
                        &::-webkit-scrollbar {
                            width: 8px;
                        }
                        &::-webkit-scrollbar-track {
                            background-color: transparent;
                        }
                        &::-webkit-scrollbar-thumb {
                            background-color: #8fc2ff;
                            border-radius: 5px;
                        }
                        // ie
                        scrollbar-face-color: #8fc2ff;
                        scrollbar-track-color: transparent;
                        scrollbar-highlight-color: #292F33;
                        scrollbar-base-color:#8fc2ff;

                        .new-box__item {
                            width: 100%;
                            height: pxTorem(62px);
                            box-sizing: border-box;
                            border-bottom: 1px dashed #d9d9d9;
                            color: #fff;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            cursor: pointer;
                            position: relative;

                            &::after {
                                content: "";
                                display: block;
                                width: pxTorem(30px);
                                height: 100%;
                                background: url("../../assets/images/home/page02/tip.png") center;
                                background-size: cover;
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                opacity: 0;
                            }

                            &:hover {
                                background: #05132e;
                                &::after {
                                    opacity: 1;
                                }
                            }

                            .new_other{
                                font-size: pxTorem(16px);
                                box-sizing: border-box;
                                margin-bottom: pxTorem(5px);

                                &--time {
                                    margin-right: pxTorem(15px);
                                }
                                &--type {
                                    padding: pxTorem(1px) pxTorem(3px);
                                    background: #189c8f;
                                }
                            }
                            .new_title {
                                font-size: pxTorem(18px);
                                max-width: 90%;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }

        .twitter-box-shadow {
            width: pxTorem(635px);
            height: 100%;
            float: right;
            box-sizing: border-box;
            background: linear-gradient(to bottom, #34C3FF, #45FFC8);
            padding: 3px;
            
            .twitter-box {
                width: 100%;
                height: 100%;
                background: url("../../assets/images/home/page02/twitter_background.png") no-repeat;
                background-position: center 10%;
                background-size: cover;
                box-sizing: border-box;
                padding: pxTorem(110px) pxTorem(25px) pxTorem(26px);
                position: relative;

                &__logo {
                    position: absolute;
                    width: pxTorem(380px);
                    top: pxTorem(15px);
                    left: 50%;
                    transform: translateX(-50%);
                }

                &__a {
                    display: block;
                    width: pxTorem(80px);
                    position: absolute;
                    top: pxTorem(55px);
                    right: pxTorem(30px);

                    img {
                        width: 100%;
                    }
                }

                &__content {
                    width: 100%;
                    height: 100%;
                    overflow-y: auto;
                    &::-webkit-scrollbar {
                        width: 8px;
                    }
                    &::-webkit-scrollbar-track {
                        background-color: transparent;
                    }
                    &::-webkit-scrollbar-thumb {
                        background-color: #8fc2ff;
                        border-radius: 5px;
                    }
                    // ie
                    scrollbar-face-color: #8fc2ff;
                    scrollbar-track-color: transparent;
                    scrollbar-highlight-color: #292F33;
                    scrollbar-base-color:#8fc2ff;
                }
            }
            .twitter-box__content {
                .twitter-timeline {
                    color: transparent;
                }
            }
        }
        
    }
}
</style>
